import { useLazyQuery } from "@apollo/client";
import { EXPORT_ORDERS_LIST } from "components/gql/gql_queries_export";
import { GetAlertData } from "contexts/AlertContext";

import { logGQLError } from "data/functions";

export function OrdersListQuery() {
  const queryName = "OrdersList";
  const { setAlert } = GetAlertData();
  const [refetch, variables] = useLazyQuery(EXPORT_ORDERS_LIST, {
    errorPolicy: "all",
    fetchPolicy: "no-cache",

    onError: (e) => {
      // setAlert("Не удалось получить документы пользователя", "warn");
      logGQLError(queryName, e);
    },
  });
  return [refetch, variables];
}
